import { FolderDetailRoute } from "@/features/fileManager/pages/FolderDetailRoute";
import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const PATH = "/fichiers";

const FileManagerPage = lazyWithRetry(() => import("@/features/fileManager/pages/FileManagerPage"));
const fileManagerRoutes: RouteConfig[] = [
  {
    path: PATH,
    element: <FileManagerPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: `${PATH}/:id`,
    element: <FolderDetailRoute />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default fileManagerRoutes;
